import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MODE_NAMES_BY_SCALE, getModeInfo } from '../utils/musicTheory';

const InfoCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  backgroundColor: 'rgba(30, 30, 47, 0.5)',
  border: 'none',
  boxShadow: 'none',
}));

const ModeInfoDisplay = ({ rootNote, currentMode }) => {
  // Use consolidated music theory data from new module
  const modeInfoDisplay = getModeInfo(currentMode);

  // Determine which scale this mode belongs to
  const getParentScale = (modeName) => {
    for (const [scaleName, modes] of Object.entries(MODE_NAMES_BY_SCALE)) {
      if (modes.includes(modeName)) {
        return scaleName;
      }
    }
    return 'Unknown Scale';
  };

  const parentScale = getParentScale(currentMode);

  return (
    <Box className="mode-info-display" sx={{ mt: 3 }}>

      <Typography variant="h6" component="h3" gutterBottom align="center">
        {parentScale} / {currentMode} Scale
      </Typography>

      <InfoCard elevation={0}>
        <Typography variant="h6" gutterBottom>
          Description
        </Typography>
        <Typography variant="body1" paragraph>
          {modeInfoDisplay.description}
        </Typography>
      </InfoCard>

      <InfoCard elevation={0}>
        <Typography variant="h6" gutterBottom>
          Characteristic Notes
        </Typography>
        <Typography variant="body1" paragraph>
          {modeInfoDisplay.characteristicNotes}
        </Typography>
      </InfoCard>

      <InfoCard elevation={0}>
        <Typography variant="h6" gutterBottom>
          Common Use
        </Typography>
        <Typography variant="body1" paragraph>
          {modeInfoDisplay.commonUse}
        </Typography>
      </InfoCard>
    </Box>
  );
};

export default ModeInfoDisplay;
